import React, { useState } from 'react';
import '../index.css';
import LikeComponent from './LikeComponent.js';
import Stars from './Stars.js';

const ReviewComponent = ({logo, userName, timePublished, reviewRating, comment, likes, userId, reviewId}) => {
//   const [review, setReview] = useState('');

  return (
    <div className='horizontal-flex' style={{paddingTop: '15px'}}>
      <div className='col-container'>
        
        <img
            className="logo-style"
            src={logo}
            width={45}
            height={45}
        />
        
      </div>
      <div className='new-vertical-flex' style={{ width: 'auto'}}>
        <div className='horizontal-flex' style={{ width: '100%', justifyContent:'space-between'}}>
          <span className='col-container'>
            <div className=''>
              {userName}
            </div>

            <div className='published-date'>
              {timePublished}
            </div>
          </span>
          {/* <div className='col-container'>
            <div className="category-widget">
                <div style={{color:'gray', paddingLeft:'25px'}}>
                    <Stars averageRating={reviewRating} />
                </div>
                <div style={{color:'gray',}}>
                    ({reviewRating}/5 stars)
                </div>
            </div>
          </div> */}
        </div>
        <span className="review-text">
          {comment}
        </span>
        <LikeComponent 
          likes={likes}
          userId = {userId}
          reviewId={reviewId}
        />
      </div>
      <div className='col-container' style={{position:'absolute', right:'0'}}>
        <div className="category-widget">
            <div style={{color:'gray', paddingLeft:'25px'}}>
                <Stars averageRating={reviewRating}/>
            </div>
            <div style={{color:'gray',}}>
                ({reviewRating}/5 stars)
            </div>
        </div>
      </div>
    </div>
  );
};

export default ReviewComponent;
